export enum JaNee {
  ja = "ja",
  nee = "nee"
}
